import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import ComFunction from "../components/ComFunction";
import EntryBase from "../components/EntryBase";
import EntryGridAr from "../components/EntryGridAr";
import MasterBase from "../components/MasterLayout";
import {
    CellType,
    DeepCopy,
    GetExtension,
    getcontroller,
    getformid,
    getsubkey,
    isEmpty,
    isEnabled,
    NumConv,
} from "../modules/appLibrary";
import { changestatus } from "../modules/formstore";
import { datepickerclose } from "../modules/searchliststore";

export const BLInfoEntry = props => {
    const formid = getformid("BLInfoEntry", props.location.search);
    const controller = getcontroller("BLInfoEntry", props.location.search);
    const entryController = "Forms:D_BLD";
    const subkey = getsubkey(props.location.search);
    const staff = useSelector(state => state.user.accctl);
    const formstatus = useSelector(state => state.form.status);
    const datepickerOpen = useSelector(state => state.search.datepickeropen);
    const dispatch = useDispatch();
    const fnc = useRef();
    const datepickerOpenRef = useRef(false);
    const formstatusRef = useRef("");
    const entrydataRef = useRef(null);
    const detailDataRef = useRef([]);
    const detailInputColumnRef = useRef(null);
    const detailOutputColumnRef = useRef(null);
    const detailApiRef = useRef(null);
    const detailRequestIdRef = useRef(0);
    const listRowRef = useRef(null);
    const listReloadRef = useRef(null);
    const listReloadRequiredRef = useRef(false);
    const entryTransitionTimerRef = useRef(null);
    const importFileRef = useRef(null);
    const importInputPlaceOptionsRef = useRef([]);
    const importOutputPlaceOptionsRef = useRef([]);
    const placePermissionOptionsRef = useRef({
        "1": null,
        "2": null,
    });
    const [entryType, setEntryType] = useState("1");
    const [detailViewType, setDetailViewType] = useState("1");
    const [editingCode, setEditingCode] = useState("");
    const [entryLoading, setEntryLoading] = useState(false);
    const [entryVersion, setEntryVersion] = useState(0);
    const ComFunc = React.forwardRef(ComFunction);
    const CELLTYPE = CellType();
    const COPY_CLEAR_HEADER_COLUMNS = [
        "BLD_BLNO",
        "BLD_INVALID",
        "BLD_DELDATETIME",
        "BLD_INPCID",
        "BLD_CREATEAC",
        "BLD_CREATEDATE",
        "BLD_UPPCID",
        "BLD_UPDATEAC",
        "BLD_UPDATE",
    ];
    const COPY_CLEAR_DETAIL_COLUMNS = [
        "BLDM_BLNO",
        "BLDM_GYONO",
        "BLDM_INVALID",
        "BLDM_DELDATETIME",
        "BLDM_INPCID",
        "BLDM_CREATEAC",
        "BLDM_CREATEDATE",
        "BLDM_UPPCID",
        "BLDM_UPDATEAC",
        "BLDM_UPDATE",
    ];

    datepickerOpenRef.current = datepickerOpen;
    formstatusRef.current = formstatus;

    function UpdateEntryTypes(value) {
        const normalized = String(value || "1") === "2"
            ? "2"
            : "1";
        setEntryType(normalized);
        setDetailViewType(normalized);
        return normalized;
    }

    function GetEffectiveDetailType() {
        const currentType = String(
            entrydataRef.current?.BLD_YUSHUTUNYUKBN || "").trim();
        if (currentType === "1" || currentType === "2") {
            return currentType;
        }

        return String(detailViewType || "1") === "2"
            ? "2"
            : "1";
    }

    function GetExcelFileName() {
        let currentType = "";

        try {
            currentType = String(
                fnc.current?.ListOption?.()?.BLD_YUSHUTUNYUKBN || "").trim();
        } catch (e) {
            currentType = "";
        }

        if (currentType !== "1" && currentType !== "2") {
            const selectedRadio = Array.from(
                document.querySelectorAll('input[type="radio"]'))
                .find(input => {
                    if (!input.checked) {
                        return false;
                    }

                    const labelText = String(
                        input.closest("label")?.textContent
                        || input.parentElement?.textContent
                        || "").trim();
                    return labelText.indexOf("入力") !== -1
                        || labelText.indexOf("輸入") !== -1
                        || labelText.indexOf("出力") !== -1
                        || labelText.indexOf("輸出") !== -1;
                });

            if (!isEmpty(selectedRadio)) {
                const labelText = String(
                    selectedRadio.closest("label")?.textContent
                    || selectedRadio.parentElement?.textContent
                    || "").trim();
                currentType = labelText.indexOf("出力") !== -1
                    || labelText.indexOf("輸出") !== -1
                    ? "2"
                    : "1";
            }
        }

        const exportType = String(
            currentType
            || entrydataRef.current?.BLD_YUSHUTUNYUKBN
            || entryType
            || "1").trim() === "2"
            ? "輸出"
            : "輸入";
        const now = new Date();
        const yyyy = String(now.getFullYear());
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        const hh = String(now.getHours()).padStart(2, "0");
        const mi = String(now.getMinutes()).padStart(2, "0");

        return "BLInfoEntry_" + exportType + "_"
            + yyyy + mm + dd + "_"
            + hh + mi + ".xlsx";
    }

    function GetPlaceCodeLabel(targetType = entryType) {
        return String(targetType || "1") === "2"
            ? "所有部門コード"
            : "取引先コード";
    }

    function GetEntryTypeLabel(targetType) {
        return String(targetType || "1") === "2"
            ? "輸出"
            : "輸入";
    }

    function DetectImportEntryTypeFromHeader(headerTitle) {
        const title = String(headerTitle || "").trim();
        if (title === "取引先コード") {
            return "1";
        }

        if (title === "所有部門コード") {
            return "2";
        }

        return "";
    }

    function DetectImportEntryTypeFromFileName(fileName) {
        const name = String(fileName || "").trim();
        if (isEmpty(name)) {
            return "";
        }

        if (name.indexOf("輸出") !== -1) {
            return "2";
        }

        if (name.indexOf("輸入") !== -1) {
            return "1";
        }

        return "";
    }

    function BuildImportHeaderWarnings(fileName, headerTitle, message) {
        const displayFileName = isEmpty(fileName)
            ? "（ファイル名不明）"
            : fileName;
        const displayHeaderTitle = isEmpty(headerTitle)
            ? "（空白）"
            : headerTitle;

        return [CreateInputWarning(
            "1",
            "IMPORT",
            "1",
            "HEADER_ROW1",
            "1行目タイトル",
            message
                + "（ファイル名："
                + displayFileName
                + "　1行目タイトル："
                + displayHeaderTitle
                + "）")];
    }

    function BuildImportErrorWarnings(message) {
        return [CreateInputWarning(
            "1",
            "IMPORT",
            "1",
            "IMPORT_ERROR",
            "取込チェック",
            String(message || "").trim())];
    }

    function FindImportFormatWarning(rows, fileName) {
        const name = isEmpty(fileName) ? "取込ファイル" : fileName;
        const targetRows = Array.isArray(rows) ? rows : [];

        for (let index = 0; index < targetRows.length; index++) {
            const row = NormalizeRowKeys(targetRows[index]);
            const placeCode = String(row.PLACECODE || "").trim();
            const invoiceNo = String(row.INVOICENO || "").trim();
            const invoiceEda = String(row.INVOICEEDA || "").trim();
            const rowNo = String(row.IMPORT_ROWNO || index + 1);
            const displayKey = "「"
                + placeCode
                + invoiceNo
                + "-"
                + invoiceEda
                + "」";

            if (isEmpty(placeCode)
                && isEmpty(invoiceNo)
                && isEmpty(invoiceEda)) {
                continue;
            }

            if (isEmpty(placeCode)) {
                return CreateInputWarning(
                    "IMPORT_FORMAT_" + rowNo,
                    "D_BLDM",
                    "102",
                    "PLACECODE",
                    "場所コード",
                    "該当するインボイスが見つかりませんでした。（ファイル名："
                    + name
                    + "　行："
                    + rowNo
                    + "）："
                    + displayKey);
            }

            if (isEmpty(invoiceNo)) {
                return CreateInputWarning(
                    "IMPORT_FORMAT_" + rowNo,
                    "D_BLDM",
                    "102",
                    "INVOICENO",
                    "InvoiceNo.",
                    "Commercial以外のインボイスです。（ファイル名："
                    + name
                    + "　行："
                    + rowNo
                    + "）："
                    + displayKey);
            }

            if (isEmpty(invoiceEda) || !/^\d+$/.test(invoiceEda)) {
                return CreateInputWarning(
                    "IMPORT_FORMAT_" + rowNo,
                    "D_BLDM",
                    "102",
                    "INVOICEEDA",
                    "InvoiceEda",
                    "インボイス枝番は数値以外入力できません。（ファイル名："
                    + name
                    + "　行："
                    + rowNo
                    + "）："
                    + displayKey);
            }
        }

        return null;
    }

    function GetDetailColumnRef(targetType = detailViewType) {
        return String(targetType || "1") === "2"
            ? detailOutputColumnRef
            : detailInputColumnRef;
    }

    function ResetDetailColumnRefs() {
        detailInputColumnRef.current = null;
        detailOutputColumnRef.current = null;
    }

    React.useEffect(() => {
        if (formstatus !== "COPY FORM"
            || isEmpty(entrydataRef.current)) {
            return;
        }

        const baseData = {
            ...entrydataRef.current,
        };
        const detailRows = GetCurrentDetailRows()
            .map((row, index) => {
                const copiedRow = {
                    ...row,
                    rowid: "BLInfoEntryCopyDetail_" + Date.now() + "_" + index,
                };

                COPY_CLEAR_DETAIL_COLUMNS.forEach(columnid => {
                    copiedRow[columnid] = "";
                });

                if (detailViewType === "1") {
                    copiedRow.BLDM_KEIHISIIRESAKIKBN = "1";
                    copiedRow.M_CODE_NAME = "仕入先";
                    copiedRow.BLDM_KEIHISIIRESAKISUBCD = "00000";
                }

                return copiedRow;
            });

                COPY_CLEAR_HEADER_COLUMNS.forEach(columnid => {
            baseData[columnid] = "";
        });

        entrydataRef.current = baseData;
        detailRequestIdRef.current += 1;
        setEditingCode("");

        ApplyDetailData(
            detailRows.length === 0
                ? [CreateEmptyDetailRow(entryType)]
                : detailRows,
            detailViewType);
        CalculateDetailTotal();
        fnc.current?.modify(false);
        fnc.current?.entryrerender();
        setEntryVersion(version => version + 1);
    }, [formstatus]);

    function BuildSelectOptions(rows, key) {
        const values = (Array.isArray(rows) ? rows : [])
            .map(row => String(row?.[key] || "").trim())
            .filter(value => !isEmpty(value));

        return Array.from(new Set(values))
            .map(value => ({ code: value, name: value }));
    }

    function BuildSingleColumnSelectData(columnid, options) {
        return {
            datatype: String(CELLTYPE.SELECT),
            dataid: "",
            keyinfo: "",
            primary: false,
            columnid: columnid,
            options: options,
        };
    }

    function FilterSelectableOptions(options) {
        const uniqueMap = new Map();

        (Array.isArray(options) ? options : []).forEach(item => {
            const code = String(item?.code || "").trim();
            if (isEmpty(code) || uniqueMap.has(code)) {
                return;
            }

            uniqueMap.set(
                code,
                {
                    code,
                    name: String(item?.name || "").trim(),
                });
        });

        return Array.from(uniqueMap.values());
    }

    function GetImportPlaceOptions(targetType) {
        return String(targetType || entryType || "1") === "2"
            ? importOutputPlaceOptionsRef.current
            : importInputPlaceOptionsRef.current;
    }

    function SetImportPlaceOptions(targetType, options) {
        if (String(targetType || entryType || "1") === "2") {
            importOutputPlaceOptionsRef.current = options;
            return;
        }

        importInputPlaceOptionsRef.current = options;
    }

    function ClearImportPlaceOptions(targetType = "") {
        if (targetType === "1" || targetType === "2") {
            SetImportPlaceOptions(targetType, []);
            return;
        }

        importInputPlaceOptionsRef.current = [];
        importOutputPlaceOptionsRef.current = [];
    }

    function BuildImportPlaceOptions(rows, targetType) {
        const normalizedType = String(targetType || entryType || "1");
        const nameField = String(targetType || entryType || "1") === "2"
            ? "ISSO_SYOYUSOSIKINM"
            : "TOR_NAME";
        const uniqueMap = new Map();

        (Array.isArray(rows) ? rows : []).forEach(row => {
            const normalized = NormalizeRowKeys(row);
            const code = GetPlacePermissionCode(normalized, normalizedType);
            if (isEmpty(code) || uniqueMap.has(code)) {
                return;
            }

            uniqueMap.set(
                code,
                {
                    code: code,
                    name: String(
                        normalized?.NAME
                        || normalized?.[nameField]
                        || (normalizedType === "2"
                            ? normalized?.TOR_NAME
                                || normalized?.IBTB_TORIATUKAIBRANDNM
                                || normalized?.IBTB_BRDRNAME
                            : normalized?.TOR_NAME
                                || normalized?.TOR_NAMERNM
                                || normalized?.IBTB_TORIATUKAIBRANDNM
                                || normalized?.IBTB_BRDRNAME)
                        || ""
                    ).trim(),
                });
        });

        return Array.from(uniqueMap.values());
    }

    function GetPlacePermissionCode(row, targetType) {
        const normalized = NormalizeRowKeys(row);
        return String(
            String(targetType || entryType || "1") === "2"
                ? normalized.BLDM_SYOYUBUMON
                    || normalized.IVD_SYOYUBUMON
                    || normalized.BLDM_KEIHISIIRESAKICD
                    || normalized.IUST_JYOUGENSOSIKIKAISOCD
                    || normalized.IBTB_SYOYUSOSIKICD
                    || normalized.ISSO_SYOYUSOSIKICD
                    || normalized.PLACECODE
                    || normalized.CODE
                    || ""
                : normalized.BLDM_KEIHISIIRESAKICD
                    || normalized.IVD_SIIRESAKICD
                    || normalized.TOR_CODE
                    || normalized.PLACECODE
                    || normalized.CODE
                    || ""
        ).trim();
    }

    function OpenInputSupplierCodeSearch(payload, originalSearchListOpen) {
        const requestRow = {
            ...(entrydataRef.current || {}),
            ...(payload?.rowdata || {}),
            BLD_YUSHUTUNYUKBN: "1",
        };

        fnc.current.postaxios(
            "BLInfoEntry/GetInputSupplierCandidates",
            {
                data: requestRow,
            },
            {
                onSuccess: function (data) {
                    const options = FilterSelectableOptions(
                        BuildImportPlaceOptions(data?.rowdata, "1"));

                    if (!Array.isArray(options) || options.length === 0) {
                        fnc.current.warnmsg("取引先が見つかりません。");
                        return;
                    }

                    placePermissionOptionsRef.current["1"] = options;

                    originalSearchListOpen({
                        label: payload?.label
                            || payload?.data?.columnnm
                            || GetPlaceCodeLabel("1"),
                        multiple: false,
                        rowmode: false,
                        rowid: payload?.rowid,
                        currowid: payload?.currowid,
                        rowdata: payload?.rowdata,
                        data: BuildSingleColumnSelectData(
                            payload?.data?.columnid,
                            options),
                        doApply: ApplyImportedPlaceCodeSearchResult,
                    });
                },
                onError: function (data) {
                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "取引先コード候補の取得に失敗しました。");
                },
                errmsg: "取引先コード候補の取得に失敗しました。",
            },
            true);
    }

    function OpenOutputOwnershipCodeSearch(payload, originalSearchListOpen) {
        const requestRow = {
            ...(entrydataRef.current || {}),
            ...(payload?.rowdata || {}),
            BLD_YUSHUTUNYUKBN: "2",
        };

        fnc.current.postaxios(
            "BLInfoEntry/GetOutputOwnershipCandidates",
            {
                data: requestRow,
            },
            {
                onSuccess: function (data) {
                    const options = FilterSelectableOptions(
                        BuildImportPlaceOptions(data?.rowdata, "2"));

                    if (!Array.isArray(options) || options.length === 0) {
                        fnc.current.warnmsg("所有部門が見つかりません。");
                        return;
                    }

                    placePermissionOptionsRef.current["2"] = options;

                    originalSearchListOpen({
                        label: payload?.label
                            || payload?.data?.columnnm
                            || GetPlaceCodeLabel("2"),
                        multiple: false,
                        rowmode: false,
                        rowid: payload?.rowid,
                        currowid: payload?.currowid,
                        rowdata: payload?.rowdata,
                        data: BuildSingleColumnSelectData(
                            payload?.data?.columnid,
                            options),
                        doApply: ApplyImportedPlaceCodeSearchResult,
                    });
                },
                onError: function (data) {
                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "所有部門コード候補の取得に失敗しました。");
                },
                errmsg: "所有部門コード候補の取得に失敗しました。",
            },
            true);
    }

    function ApplyImportedPlaceCodeSearchResult(e) {
        const rowId = Array.isArray(e?.rowid) && e.rowid.length > 0
            ? e.rowid[0]
            : e?.currowid;
        const api = detailApiRef.current;
        const rowNode = isEmpty(api) || isEmpty(rowId)
            ? null
            : api.getRowNode(rowId);
        const columnid = String(e?.key || "").trim();

        if (isEmpty(rowNode) || isEmpty(columnid)) {
            fnc.current.searchlistclose();
            return;
        }

        const targetType = columnid === "BLDM_SYOYUBUMON"
            ? "2"
            : "1";
        const selected = NormalizeRowKeys(
            Array.isArray(e?.selectedRows) && e.selectedRows.length > 0
                ? e.selectedRows[0]
                : null);
        const selectedCode = String(
            selected.CODE
            || selected.ISSO_SYOYUSOSIKICD
            || selected.TOR_CODE
            || e?.value
            || "").trim();
        const optionSource =
            (Array.isArray(placePermissionOptionsRef.current?.[targetType])
                && placePermissionOptionsRef.current[targetType].length > 0
                ? placePermissionOptionsRef.current[targetType]
                : (Array.isArray(GetImportPlaceOptions(targetType))
                    ? GetImportPlaceOptions(targetType)
                    : []));
        const option = !isEmpty(selectedCode)
            ? optionSource.find(
                item => String(item?.code || "") === selectedCode)
            : null;
        const optionName = String(
            selected.NAME
            || selected.ISSO_SYOYUSOSIKINM
            || selected.TOR_NAME
            || option?.name
            || "").trim();

        if (isEmpty(selectedCode)) {
            fnc.current.searchlistclose();
            return;
        }

        if (columnid === "BLDM_SYOYUBUMON") {
            Object.assign(
                rowNode.data,
                {
                    BLDM_SYOYUBUMON: selectedCode,
                    ISSO_SYOYUSOSIKINM: optionName,
                    BLDM_INVOICENO: "",
                    BLDM_INVOICEEDA: "",
                    IVD_MOTOINVOICEENTOTAL: 0,
                    IVD_TSUKATANI: "",
                    IVDM_KINGAKUF: 0,
                });
        } else {
            Object.assign(
                rowNode.data,
                {
                    BLDM_KEIHISIIRESAKIKBN: "1",
                    M_CODE_NAME: "仕入先",
                    BLDM_KEIHISIIRESAKICD: selectedCode,
                    BLDM_KEIHISIIRESAKISUBCD: "00000",
                    TOR_NAME: optionName,
                    BLDM_INVOICENO: "",
                    BLDM_INVOICEEDA: "",
                    IVD_MOTOINVOICEENTOTAL: 0,
                    IVD_TSUKATANI: "",
                    IVDM_KINGAKUF: 0,
                });
        }

        api.refreshCells({
            rowNodes: [rowNode],
            force: true,
        });

        CalculateDetailTotal();
        fnc.current.modify();
        fnc.current.searchlistclose();
    }

    function BuildInvoiceSearchRequestRow(rowdata, override = {}) {
        return {
            ...(entrydataRef.current || {}),
            ...(rowdata || {}),
            ...override,
        };
    }

    function OpenInvoiceNoCommonSearch(payload, originalSearchListOpen) {
        const rowdata = payload?.rowdata || {};
        const type = String(
            rowdata?.BLD_YUSHUTUNYUKBN
            || entrydataRef.current?.BLD_YUSHUTUNYUKBN
            || entryType
            || "1");
        const targetValue = type === "2"
            ? String(rowdata?.BLDM_SYOYUBUMON || "").trim()
            : String(rowdata?.BLDM_KEIHISIIRESAKICD || "").trim();

        if (isEmpty(targetValue)) {
            fnc.current.warnmsg(
                type === "2"
                    ? "先に所有部門コードを選択してください。"
                    : "先に取引先コードを選択してください。");
            return;
        }

        const requestRow = BuildInvoiceSearchRequestRow(
            rowdata,
            {
                BLD_YUSHUTUNYUKBN: type,
            });

        fnc.current.postaxios(
            "BLInfoEntry/GetInvoiceNoCandidates",
            {
                data: requestRow,
            },
            {
                onSuccess: function (data) {
                    const options = BuildSelectOptions(
                        data?.rowdata,
                        "IVD_INVOICENO");
                    if (!Array.isArray(options) || options.length === 0) {
                        fnc.current.warnmsg("Invoiceが見つかりません。");
                        return;
                    }
                    originalSearchListOpen({
                        label: "InvoiceNo.",
                        multiple: false,
                        rowmode: false,
                        rowid: payload?.rowid,
                        currowid: payload?.currowid,
                        rowdata: requestRow,
                        data: BuildSingleColumnSelectData(
                            "BLDM_INVOICENO",
                            options),
                        doApply: ApplyInvoiceNoCommonSearchResult,
                    });
                },
                onError: function (data) {
                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "InvoiceNo.候補の取得に失敗しました。");
                },
                errmsg: "InvoiceNo.候補の取得に失敗しました。",
            },
            true);
    }

    function ApplyInvoiceNoCommonSearchResult(e) {
        const rowId = Array.isArray(e?.rowid) && e.rowid.length > 0
            ? e.rowid[0]
            : e?.currowid;
        const api = detailApiRef.current;
        const rowNode = isEmpty(api) || isEmpty(rowId)
            ? null
            : api.getRowNode(rowId);

        if (isEmpty(rowNode)) {
            fnc.current.searchlistclose();
            return;
        }

        Object.assign(
            rowNode.data,
            {
                BLDM_INVOICENO: e?.value || "",
                BLDM_INVOICEEDA: "",
                IVD_MOTOINVOICEENTOTAL: 0,
                IVD_TSUKATANI: "",
                IVDM_KINGAKUF: 0,
            });

        api.refreshCells({
            rowNodes: [rowNode],
            force: true,
        });
        CalculateDetailTotal();
        fnc.current.modify();

        fnc.current.searchlistclose();
    }

    function OpenInvoiceEdaCommonSearch(payload, originalSearchListOpen) {
        const rowdata = payload?.rowdata || {};
        const invoiceNo = String(rowdata?.BLDM_INVOICENO || "").trim();
        if (isEmpty(invoiceNo)) {
            fnc.current.warnmsg("先にInvoiceNo.を選択または入力してください。");
            return;
        }

        const requestRow = BuildInvoiceSearchRequestRow(rowdata);

        fnc.current.postaxios(
            "BLInfoEntry/GetInvoiceEdaCandidates",
            {
                data: requestRow,
            },
            {
                onSuccess: function (data) {
                    const options = BuildSelectOptions(
                        data?.rowdata,
                        "IVD_INVOICEEDA");
                    if (!Array.isArray(options) || options.length === 0) {
                        fnc.current.warnmsg("Invoice枝番が見つかりません。");
                        return;
                    }
                    originalSearchListOpen({
                        label: "Invoice枝番",
                        multiple: false,
                        rowmode: false,
                        rowid: payload?.rowid,
                        currowid: payload?.currowid,
                        rowdata: requestRow,
                        data: BuildSingleColumnSelectData(
                            "BLDM_INVOICEEDA",
                            options),
                        doApply: ApplyInvoiceEdaCommonSearchResult,
                    });
                },
                onError: function (data) {
                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "Invoice枝番候補の取得に失敗しました。");
                },
                errmsg: "Invoice枝番候補の取得に失敗しました。",
            },
            true);
    }

    function ApplyInvoiceEdaCommonSearchResult(e) {
        const rowId = Array.isArray(e?.rowid) && e.rowid.length > 0
            ? e.rowid[0]
            : e?.currowid;
        const api = detailApiRef.current;
        const rowNode = isEmpty(api) || isEmpty(rowId)
            ? null
            : api.getRowNode(rowId);

        if (isEmpty(rowNode)) {
            fnc.current.searchlistclose();
            return;
        }

        rowNode.data.BLDM_INVOICEEDA = e?.value || "";
        api.refreshCells({
            rowNodes: [rowNode],
            force: true,
        });

        LoadDetailReferenceInfo(
            rowNode.data,
            "BLDM_INVOICEEDA",
            {
                api: api,
                node: rowNode,
            });

        fnc.current.searchlistclose();
    }

    // 日付選択後は日付ピッカーだけを閉じる。
    // 共通の検索画面終了処理を使用すると、日付項目情報が先にクリアされるため、
    // DatePicker の終了時イベントで null を参照する場合がある。
    const SetComFunctionRef = React.useCallback(instance => {
        if (instance === null) {
            fnc.current = null;
            return;
        }

        if (!instance.blInfoDateCloseWrapped) {
            const closeSearchList = instance.searchlistclose.bind(instance);
            instance.searchlistclose = () => {
                if (datepickerOpenRef.current) {
                    dispatch(datepickerclose());
                    return;
                }
                closeSearchList();
            };
            instance.blInfoDateCloseWrapped = true;
        }

        if (!instance.blInfoInvoiceSearchWrapped) {
            const originalSearchListOpen = instance.searchlistopen.bind(instance);
            instance.searchlistopen = payload => {
                if (payload?.data?.columnid === "BLDM_KEIHISIIRESAKICD") {
                    OpenInputSupplierCodeSearch(payload, originalSearchListOpen);
                    return;
                }
                if (payload?.data?.columnid === "BLDM_SYOYUBUMON") {
                    OpenOutputOwnershipCodeSearch(payload, originalSearchListOpen);
                    return;
                }
                if (payload?.data?.columnid === "BLDM_INVOICENO") {
                    OpenInvoiceNoCommonSearch(payload, originalSearchListOpen);
                    return;
                }
                if (payload?.data?.columnid === "BLDM_INVOICEEDA") {
                    OpenInvoiceEdaCommonSearch(payload, originalSearchListOpen);
                    return;
                }
                originalSearchListOpen(payload);
            };
            instance.blInfoInvoiceSearchWrapped = true;
        }

        fnc.current = instance;
    }, [dispatch]);

    const actionurl = {
        update: "BLInfoEntry/UpdateEntry",
        getlist: "BLInfoEntry/GetListData",
    };

    const navmenu = [
        {
            status: "VIEW",
            menuid: "blexcel",
            icon: "file_download",
            label: "Excel",
            title: "現在のシート内容をExcelに出力します",
        },
        {
            status: "NEW FORM",
            menuid: "blimport",
            icon: "post_add",
            label: "データ取込",
            title: "Invoiceデータ検索のExcel形式を取り込みます",
        },
        {
            status: "ENTRY FORM",
            menuid: "blimport",
            icon: "post_add",
            label: "データ取込",
            title: "Invoiceデータ検索のExcel形式を取り込みます",
        },
    ];

    // 一覧画面では設計書に従い、直接更新・追加のステータスを表示しない。
    // 更新は ENTRY FORM、新規登録は NEW FORM から行う。
    const suppressaction = [
        { type: "*", action: "UPDATE" },
        { type: "*", action: "INSERT" },
    ];

    const statusPanel = {
        id: "0",
        type: "0",
        name: "ステータス",
    };
    const basePanel = {
        id: "1",
        type: "1",
        name: "基本情報",
    };
    const effectiveDetailType = GetEffectiveDetailType();

    const detailPanel = {
        id: "2",
        type: "102",
        name: entryLoading
            ? "明細"
            : effectiveDetailType === "2"
                ? "明細（輸出用）"
                : "明細（輸入用）",
        grid: true,
        initrow: 1,
        maxrow: 0,
    };

    const statusFields = [
        CreateField("BLD_CREATEAC", "作成者", "0", CELLTYPE.TEXT, 0, true),
        CreateField(
            "BLD_CREATEDATE",
            "作成日",
            "0",
            CELLTYPE.TEXT,
            0,
            true,
            false,
            false,
            { length: 19, format: "yyyy/MM/dd HH:mm:ss" }),
        CreateField("BLD_UPDATEAC", "更新者", "0", CELLTYPE.TEXT, 0, true),
        CreateField(
            "BLD_UPDATE",
            "更新日",
            "0",
            CELLTYPE.TEXT,
            0,
            true,
            false,
            false,
            { length: 19, format: "yyyy/MM/dd HH:mm:ss" }),
    ];
    const baseFields = [
        CreateField(
            "BLD_BLNO",
            "B/L No.",
            "1",
            CELLTYPE.TEXT,
            0,
            formstatus !== "NEW FORM",
            true,
            true),
        CreateField("BLD_INPUTDATE", "入力日", "1", CELLTYPE.DATE, 0, false, true),
        CreateField(
            "BLD_INPUTTANTOCD",
            "入力担当",
            "1",
            CELLTYPE.MASTER,
            0,
            false,
            false,
            false,
            {
                dataid: "M_TAN",
                dbcolumn: "TAN_NAME",
                length: 10,
                format: "padzero",
            }),
        CreateField(
            "BLD_YUSHUTUNYUKBN",
            "Exp/Imp",
            "1",
            CELLTYPE.SPIN,
            0,
            false,
            false,
            false,
            {
                length: 1,
                options: [
                    { code: "1", name: "輸入" },
                    { code: "2", name: "輸出" },
                ],
                unchange: true,
            }),
        CreateField("BLD_SOZAIFLG", "素材", "1", CELLTYPE.CHECK, 0),
        CreateField("BLD_ZANPACHIFLG", "暫八", "1", CELLTYPE.CHECK, 0),
        CreateField(
            "BLD_CARTONSU",
            "カートン数",
            "1",
            CELLTYPE.NUM,
            0,
            false,
            false,
            false,
            { length: 5, decimalplace: 0 }),
        CreateField(
            "BLD_GWT",
            "GWT",
            "1",
            CELLTYPE.NUM,
            0,
            false,
            false,
            false,
            { length: 10, decimalplace: 2 }),
        CreateField(
            "BLD_M3",
            "M3",
            "1",
            CELLTYPE.NUM,
            0,
            false,
            false,
            false,
            { length: 10, decimalplace: 2 }),
        CreateField(
            "BLD_POL",
            "POL",
            "1",
            CELLTYPE.MASTER,
            0,
            false,
            false,
            false,
            {
                dataid: "M_CPOL",
                dbcolumn: "CPOL_NAME",
                length: 3,
                format: "padzero",
                searchparam: {
                    requirement: "where=ISNULL(CPOL_HIDECHECK, 0) = 0 AND ISNULL(CPOL_INVALID, 0) = 0",
                },
            }),
        CreateField(
            "BLD_POD",
            "POD",
            "1",
            CELLTYPE.MASTER,
            0,
            false,
            false,
            false,
            {
                dataid: "M_CPOD",
                dbcolumn: "CPOD_NAME",
                length: 3,
                format: "padzero",
                searchparam: {
                    requirement: "where=ISNULL(CPOD_HIDECHECK, 0) = 0 AND ISNULL(CPOD_INVALID, 0) = 0",
                },
            }),
        CreateField(
            "BLD_YUSOU",
            "輸送方法",
            "1",
            CELLTYPE.MASTERCODE,
            0,
            false,
            false,
            false,
            {
                dataid: "m_code:0145",
                length: 2,
                format: "padzero",
            }),
        CreateField("BLD_SYUKOUBI", "出港日", "1", CELLTYPE.DATE, 0),
        CreateField("BLD_NYUKOUBI", "入港日", "1", CELLTYPE.DATE, 0),
        CreateField("BLD_TUKANBI", "通関日", "1", CELLTYPE.DATE, 0),
        CreateField("BLD_HAITATUBI", "配送日", "1", CELLTYPE.DATE, 0),
        CreateField("BLD_TEKIYO", "摘要", "1", CELLTYPE.TEXT, 3),
    ];
    const detailFields = GetDetailFields(effectiveDetailType);
    const inputDetailFields = GetDetailFields("1");
    const outputDetailFields = GetDetailFields("2");
    const detailColumns = detailFields.map(field => ({
        columnid: field.columnid,
        type: field.type,
        width: GetDetailColumnWidth(field.columnid),
        hidden: "0",
    }));
    const inputDetailColumns = inputDetailFields.map(field => ({
        columnid: field.columnid,
        type: field.type,
        width: GetDetailColumnWidth(field.columnid),
        hidden: "0",
    }));
    const outputDetailColumns = outputDetailFields.map(field => ({
        columnid: field.columnid,
        type: field.type,
        width: GetDetailColumnWidth(field.columnid),
        hidden: "0",
    }));
    const backendColumnInfo = GetBackendColumnInfo();

    function CreateField(
        columnid,
        columnnm,
        type,
        datatype,
        width,
        locked = false,
        required = false,
        primary = false,
        settings = {}) {
        const detailTable = String(columnid).startsWith("BLDM_")
            ? "D_BLDM"
            : "";
        const table = String(type) === "102"
            ? detailTable
            : "D_BLD";
        const noSaveColumns = [
            "BLD_CREATEAC",
            "BLD_CREATEDATE",
            "BLD_UPDATEAC",
            "BLD_UPDATE",
            "BLD_INVALID",
            "BLDM_INVALID",
            "BLDM_DELDATETIME",
            "BLDM_INPCID",
            "BLDM_CREATEAC",
            "BLDM_CREATEDATE",
            "BLDM_UPPCID",
            "BLDM_UPDATEAC",
            "BLDM_UPDATE",
        ];

        return {
            table: table,
            columnid: columnid,
            columnnm: columnnm,
            type: type,
            datatype: datatype,
            width: width,
            locked: locked,
            required: required,
            saveed: !isEmpty(table)
                && !noSaveColumns.includes(columnid),
            primary: primary,
            unchange: false,
            multiple: false,
            length: 0,
            decimalplace: 0,
            format: "",
            hidden: "0",
            initvalue: "",
            options: [],
            dataid: "",
            dbcolumn: "",
            keyinfo: "",
            searchparam: {},
            trigger: [],
            ...settings,
        };
    }

    function GetDetailFields(targetType) {
        const commonFields = [
            CreateField(
                "BLDM_INVOICENO",
                "InvoiceNo.",
                "102",
                CELLTYPE.MASTERCODE,
                0,
                false,
                true,
                false,
                {
                    dataid: "D_IVD",
                    length: 20,
                    searchparam: {},
                }),
            CreateField(
                "BLDM_INVOICEEDA",
                "（Invoice No. 枝番）",
                "102",
                CELLTYPE.MASTERCODE,
                0,
                false,
                true,
                false,
                {
                    dataid: "D_IVD",
                    length: 4,
                    searchparam: {},
                }),
            CreateField(
                "IVD_MOTOINVOICEENTOTAL",
                "金額",
                "102",
                CELLTYPE.NUM,
                0,
                true,
                false,
                false,
                { length: 10, decimalplace: 2 }),
            CreateField("IVD_TSUKATANI", "通貨単位", "102", CELLTYPE.TEXT, 0, true),
            CreateField(
                "IVDM_KINGAKUF",
                "金額（外）",
                "102",
                CELLTYPE.NUM,
                0,
                true,
                false,
                false,
                { length: 10, decimalplace: 2 }),
        ];

        if (targetType === "2") {
            return [
                CreateField(
                    "BLDM_SYOYUBUMON",
                    "所有部門コード",
                    "102",
                    CELLTYPE.MASTERCODE,
                    0,
                    false,
                    true,
                    false,
                    {
                        dataid: "M_ISSO",
                        dbcolumn: "ISSO_SYOYUSOSIKINM",
                        length: 5,
                        format: "padzero",
                        searchparam: {
                            requirement:
                                "where=ISNULL(ISSO_INVALID, 0) = 0",
                        },
                    }),
                CreateField("ISSO_SYOYUSOSIKINM", "所有部門名", "102", CELLTYPE.TEXT, 0, true, true),
                ...commonFields,
            ];
        }

        return [
            CreateField("BLDM_KEIHISIIRESAKIKBN", "取引先区分", "102", CELLTYPE.TEXT, 0, true, true),
            CreateField("M_CODE_NAME", "取引先区分名", "102", CELLTYPE.TEXT, 0, true, true),
            CreateField(
                "BLDM_KEIHISIIRESAKICD",
                "取引先コード",
                "102",
                CELLTYPE.MASTERCODE,
                0,
                false,
                true,
                false,
                {
                    dataid: "M_TOR",
                    dbcolumn: "TOR_NAME",
                    length: 10,
                    searchparam: {
                        requirement:
                            "where=TOR_KUBUN = '1' "
                            + "AND TOR_SUBCODE = '00000' "
                            + "AND ISNULL(TOR_INVALID, 0) = 0",
                    },
                }),
            CreateField("TOR_NAME", "取引先名", "102", CELLTYPE.TEXT, 0, true, true),
            ...commonFields,
        ];
    }

    function GetBackendColumnInfo() {
        const backendFields = [
            ...statusFields,
            ...baseFields,
            CreateField(
                "BLD_ENTOTAL",
                "金額計",
                "1",
                CELLTYPE.NUM,
                0,
                true,
                false,
                false,
                { length: 10, decimalplace: 2 }),
            CreateField("BLD_INVALID", "削除フラグ", "1", CELLTYPE.NUM, 0, true),
            ...GetDetailFields("1"),
            ...GetDetailFields("2"),
            CreateField("BLDM_BLNO", "B/L No.", "102", CELLTYPE.TEXT, 0, true),
            CreateField("BLDM_GYONO", "行番号", "102", CELLTYPE.NUM, 0, true),
            CreateField("BLDM_KEIHISIIRESAKISUBCD", "取引先サブコード", "102", CELLTYPE.TEXT, 0, true),
            CreateField("BLDM_INVALID", "削除フラグ", "102", CELLTYPE.NUM, 0, true),
            CreateField("BLDM_DELDATETIME", "削除日時", "102", CELLTYPE.DATE, 0, true),
            CreateField("BLDM_INPCID", "登録PCID", "102", CELLTYPE.TEXT, 0, true),
            CreateField("BLDM_CREATEAC", "登録担当者コード", "102", CELLTYPE.TEXT, 0, true),
            CreateField("BLDM_CREATEDATE", "登録日時", "102", CELLTYPE.DATE, 0, true),
            CreateField("BLDM_UPPCID", "更新PCID", "102", CELLTYPE.TEXT, 0, true),
            CreateField("BLDM_UPDATEAC", "更新担当者コード", "102", CELLTYPE.TEXT, 0, true),
            CreateField("BLDM_UPDATE", "更新日時", "102", CELLTYPE.DATE, 0, true),
        ];
        const keys = new Set();

        return backendFields.filter(field => {
            const key = field.type + ":" + field.columnid;
            if (keys.has(key)) {
                return false;
            }

            keys.add(key);
            return true;
        });
    }

    function GetDetailColumnWidth(columnid) {
        const widths = {
            BLDM_KEIHISIIRESAKIKBN: 110,
            M_CODE_NAME: 130,
            BLDM_KEIHISIIRESAKICD: 140,
            TOR_NAME: 180,
            BLDM_SYOYUBUMON: 140,
            ISSO_SYOYUSOSIKINM: 180,
            BLDM_INVOICENO: 170,
            BLDM_INVOICEEDA: 160,
            IVD_MOTOINVOICEENTOTAL: 130,
            IVD_TSUKATANI: 100,
            IVDM_KINGAKUF: 130,
        };

        return widths[columnid] || 120;
    }

    function CreateEmptyDetailRow(targetType = detailViewType) {
        const row = {
            rowid: "BLInfoEntryDetail_" + Date.now(),
        };

        if (targetType === "1") {
            Object.assign(
                row,
                {
                    BLDM_KEIHISIIRESAKIKBN: "1",
                    M_CODE_NAME: "仕入先",
                    BLDM_KEIHISIIRESAKISUBCD: "00000",
                });
        }

        return row;
    }

    // 輸入明細の固定値は、初期行だけでなく追加・挿入された行にも設定する。
    function InitializeAddedDetailRows() {
        if (detailViewType !== "1") {
            return true;
        }

        window.setTimeout(
            () => {
                const api = detailApiRef.current;
                if (isEmpty(api)
                    || (typeof api.isDestroyed === "function"
                        && api.isDestroyed())) {
                    return;
                }

                const changedNodes = [];
                api.forEachNode(node => {
                    let changed = false;
                    if (isEmpty(node.data.BLDM_KEIHISIIRESAKIKBN)) {
                        node.data.BLDM_KEIHISIIRESAKIKBN = "1";
                        changed = true;
                    }
                    if (isEmpty(node.data.M_CODE_NAME)) {
                        node.data.M_CODE_NAME = "仕入先";
                        changed = true;
                    }
                    if (isEmpty(node.data.BLDM_KEIHISIIRESAKISUBCD)) {
                        node.data.BLDM_KEIHISIIRESAKISUBCD = "00000";
                        changed = true;
                    }
                    if (changed) {
                        changedNodes.push(node);
                    }
                });

                if (changedNodes.length > 0) {
                    api.refreshCells({
                        rowNodes: changedNodes,
                        force: true,
                    });
                }
            },
            0);

        return true;
    }

    // BL経費入力と同じ形式で、金額計を小数2桁・3桁区切りで表示する。
    function FormatTotalAmount(value) {
        if (isEmpty(value)) {
            return "";
        }

        const normalizedValue = typeof value === "string"
            ? value.replace(/,/g, "")
            : value;
        const numberValue = Number(normalizedValue);

        if (Number.isNaN(numberValue)) {
            return value;
        }

        return numberValue.toLocaleString(
            undefined,
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
    }

    // BL経費入力と同じく、表示用のカンマを除去して数値化する。
    function ToNumber(value) {
        const normalizedValue = typeof value === "string"
            ? value.replace(/,/g, "")
            : value;

        return NumConv(normalizedValue);
    }

    function GetCurrentDetailRows() {
        const api = detailApiRef.current;
        if (!isEmpty(api)
            && !(typeof api.isDestroyed === "function" && api.isDestroyed())) {
            const rows = [];
            api.forEachNode(node => rows.push(node.data));
            detailDataRef.current = rows;
        }

        return Array.isArray(detailDataRef.current)
            ? detailDataRef.current
            : [];
    }

    function CalculateDetailTotal() {
        const total = GetCurrentDetailRows().reduce(
            (result, row) =>
                result + ToNumber(row.IVD_MOTOINVOICEENTOTAL),
            0);

        entrydataRef.current = {
            ...entrydataRef.current,
            BLD_ENTOTAL: total,
        };
    }

    function BuildImportedDetailRows(rows, targetType) {
        return (Array.isArray(rows) ? rows : [])
            .map(row => NormalizeRowKeys(row))
            .filter(row => !isEmpty(row))
            .map((row, index) => ({
                ...row,
                rowid: "BLInfoEntryImportDetail_"
                    + Date.now()
                    + "_"
                    + index,
                BLDM_BLNO: "",
                BLDM_GYONO: "",
                BLDM_INVALID: "0",
                BLDM_DELDATETIME: "",
                BLDM_INPCID: "",
                BLDM_CREATEAC: "",
                BLDM_CREATEDATE: "",
                BLDM_UPPCID: "",
                BLDM_UPDATEAC: "",
                BLDM_UPDATE: "",
                ...(String(targetType || "1") === "1"
                    ? {
                        BLDM_KEIHISIIRESAKIKBN: "1",
                        M_CODE_NAME: "仕入先",
                        BLDM_KEIHISIIRESAKISUBCD:
                            isEmpty(row.BLDM_KEIHISIIRESAKISUBCD)
                                ? "00000"
                                : row.BLDM_KEIHISIIRESAKISUBCD,
                    }
                    : {}),
            }));
    }

    function BuildImportDuplicateKey(row, targetType) {
        const normalized = NormalizeRowKeys(row);
        const placeCode = String(
            String(targetType || "1") === "2"
                ? normalized.BLDM_SYOYUBUMON || normalized.PLACECODE || ""
                : normalized.BLDM_KEIHISIIRESAKICD || normalized.PLACECODE || ""
        ).trim();
        const invoiceNo = String(
            normalized.BLDM_INVOICENO || normalized.INVOICENO || ""
        ).trim();
        const invoiceEda = String(
            normalized.BLDM_INVOICEEDA || normalized.INVOICEEDA || ""
        ).trim();

        if (isEmpty(placeCode)
            || isEmpty(invoiceNo)
            || isEmpty(invoiceEda)) {
            return "";
        }

        return [
            placeCode,
            invoiceNo,
            invoiceEda,
        ].join("\u001f");
    }

    function BuildImportDuplicateDisplayRow(row, targetType) {
        const normalized = NormalizeRowKeys(row);
        return {
            rowNo: Number(normalized.IMPORT_ROWNO || 0),
            placeCode: String(
                String(targetType || "1") === "2"
                    ? normalized.BLDM_SYOYUBUMON || normalized.PLACECODE || ""
                    : normalized.BLDM_KEIHISIIRESAKICD || normalized.PLACECODE || ""
            ).trim(),
            invoiceNo: String(
                normalized.BLDM_INVOICENO || normalized.INVOICENO || ""
            ).trim(),
            invoiceEda: String(
                normalized.BLDM_INVOICEEDA || normalized.INVOICEEDA || ""
            ).trim(),
        };
    }

    function BuildImportDuplicateWarnings(fileName, duplicateRows) {
        const name = isEmpty(fileName) ? "取込ファイル" : fileName;
        return (Array.isArray(duplicateRows) ? duplicateRows : []).map((row, index) =>
            CreateInputWarning(
                "IMPORT_" + String(index + 1),
                "D_BLDM",
                "102",
                "BLDM_INVOICENO",
                "InvoiceNo.",
                "インボイスが重複しています。（ファイル名："
                + name
                + "　行："
                + String(row?.rowNo || "")
                + "）：「"
                + String(row?.placeCode || "")
                + String(row?.invoiceNo || "")
                + "-"
                + String(row?.invoiceEda || "")
                + "」"
            ));
    }

    function BuildImportExcludedWarnings(fileName, rows) {
        const name = isEmpty(fileName) ? "取込ファイル" : fileName;
        return (Array.isArray(rows) ? rows : []).map((row, index) => {
            const normalized = NormalizeRowKeys(row);
            const rowNo = String(normalized.IMPORT_ROWNO || "");
            const placeCode = String(normalized.PLACECODE || "").trim();
            const invoiceNo = String(normalized.INVOICENO || "").trim();
            const invoiceEda = String(normalized.INVOICEEDA || "").trim();

            return CreateInputWarning(
                "IMPORT_EXCLUDED_" + String(index + 1),
                "D_BLDM",
                "102",
                "BLDM_INVOICENO",
                "InvoiceNo.",
                "該当するインボイスが見つかりませんでした。（ファイル名："
                + name
                + "　行："
                + rowNo
                + "）：「"
                + placeCode
                + invoiceNo
                + "-"
                + invoiceEda
                + "」"
            );
        });
    }

    function SplitImportedRowsByDuplicate(rows, targetType) {
        const currentRows = GetCurrentDetailRows()
            .map(row => NormalizeRowKeys(row));
        const currentKeys = new Set(
            currentRows
                .map(row => BuildImportDuplicateKey(row, targetType))
                .filter(key => !isEmpty(key))
        );
        const importingKeys = new Set();
        const filteredRows = [];
        const duplicateRows = [];

        (Array.isArray(rows) ? rows : []).forEach(row => {
            const key = BuildImportDuplicateKey(row, targetType);

            if (isEmpty(key)) {
                filteredRows.push(row);
                return;
            }

            if (currentKeys.has(key) || importingKeys.has(key)) {
                duplicateRows.push(BuildImportDuplicateDisplayRow(row, targetType));
                return;
            }

            importingKeys.add(key);
            filteredRows.push(row);
        });

        return {
            rows: filteredRows,
            duplicateRows: duplicateRows,
        };
    }

    function AppendImportedDetailRows(rows, targetType, isPrepared = false) {
        const currentRows = GetCurrentDetailRows()
            .map(row => NormalizeRowKeys(row));
        const existingRows = currentRows.filter(row => IsDetailSaveRow(row));
        const importedRows = isPrepared
            ? (Array.isArray(rows) ? rows : [])
            : BuildImportedDetailRows(rows, targetType);

        if (importedRows.length === 0) {
            return 0;
        }

        ApplyDetailData(
            [...existingRows, ...importedRows],
            targetType);
        CalculateDetailTotal();
        fnc.current.modify();
        fnc.current.entryrerender();
        setEntryVersion(version => version + 1);

        return importedRows.length;
    }

    function RefreshDetailRow(params) {
        if (isEmpty(params?.api)) {
            return;
        }

        params.api.refreshCells({
            rowNodes: isEmpty(params.node)
                ? undefined
                : [params.node],
            force: true,
        });
    }

    function ClearInvoiceReferenceValues(row) {
        Object.assign(
            row,
            {
                IVD_MOTOINVOICEENTOTAL: 0,
                IVD_TSUKATANI: "",
                IVDM_KINGAKUF: 0,
            });
    }

    function BuildDetailDuplicateWarningRow(row, rowNumber, targetType) {
        const placeCode = String(
            String(targetType || "1") === "2"
                ? row?.BLDM_SYOYUBUMON || ""
                : row?.BLDM_KEIHISIIRESAKICD || "")
            .trim();
        const invoiceNo = String(row?.BLDM_INVOICENO || "").trim();
        const invoiceEda = String(row?.BLDM_INVOICEEDA || "").trim();

        return CreateInputWarning(
            String(row?.rowid || rowNumber),
            "D_BLDM",
            "102",
            "BLDM_INVOICEEDA",
            "Invoice No. 枝番",
            "インボイスが重複しています。"
            + "（行："
            + rowNumber
            + "）：「"
            + placeCode
            + invoiceNo
            + "-"
            + invoiceEda
            + "」");
    }

    function FindDuplicateDetailRow(currentRow, targetType) {
        const api = detailApiRef.current;
        if (isEmpty(api) || isEmpty(currentRow)) {
            return null;
        }

        const placeColumn = String(targetType || "1") === "2"
            ? "BLDM_SYOYUBUMON"
            : "BLDM_KEIHISIIRESAKICD";
        const placeCode = String(currentRow?.[placeColumn] || "").trim();
        const invoiceNo = String(currentRow?.BLDM_INVOICENO || "").trim();
        const invoiceEda = String(currentRow?.BLDM_INVOICEEDA || "").trim();

        if (isEmpty(placeCode) || isEmpty(invoiceNo) || isEmpty(invoiceEda)) {
            return null;
        }

        const rows = [];
        api.forEachNode(node => {
            if (!isEmpty(node?.data)) {
                rows.push(node.data);
            }
        });

        const currentIndex = rows.findIndex(row =>
            row?.rowid === currentRow?.rowid);
        const duplicateIndex = rows.findIndex(row =>
            row?.rowid !== currentRow?.rowid
            && String(row?.[placeColumn] || "").trim() === placeCode
            && String(row?.BLDM_INVOICENO || "").trim() === invoiceNo
            && String(row?.BLDM_INVOICEEDA || "").trim() === invoiceEda);

        if (duplicateIndex < 0) {
            return null;
        }

        return {
            warning: BuildDetailDuplicateWarningRow(
                currentRow,
                currentIndex >= 0 ? currentIndex + 1 : duplicateIndex + 1,
                targetType),
        };
    }

    function HandleDuplicateDetailRow(row, params, targetType) {
        const duplicate = FindDuplicateDetailRow(row, targetType);
        if (isEmpty(duplicate)) {
            return false;
        }

        Object.assign(
            row,
            {
                BLDM_INVOICEEDA: "",
            });
        ClearInvoiceReferenceValues(row);
        RefreshDetailRow(params);
        CalculateDetailTotal();
        fnc.current.modify();
        setEntryVersion(version => version + 1);
        fnc.current.showwarndescription(
            "明細内容を確認してください。",
            [duplicate.warning]);

        return true;
    }

    function NeedsDetailReferenceHydration(row, targetType) {
        if (isEmpty(row)
            || isEmpty(row.BLDM_INVOICENO)
            || isEmpty(row.BLDM_INVOICEEDA)) {
            return false;
        }

        if (String(targetType || "1") === "2") {
            return isEmpty(row.BLDM_SYOYUBUMON)
                || isEmpty(row.ISSO_SYOYUSOSIKINM);
        }

        return isEmpty(row.BLDM_KEIHISIIRESAKICD)
            || isEmpty(row.TOR_NAME);
    }

    // 手入力された取引先・所有部門・Invoiceから名称、通貨、金額を取得する。
    function LoadDetailReferenceInfo(row, changedColumn, params, options = {}) {
        const suppressDirty = options?.suppressDirty === true;
        const suppressWarning = options?.suppressWarning === true;
        const requestRow = {
            ...row,
            BLD_YUSHUTUNYUKBN:
                entrydataRef.current?.BLD_YUSHUTUNYUKBN || entryType,
        };

        if (changedColumn === "BLDM_INVOICENO") {
            Object.assign(
                row,
                {
                    BLDM_INVOICEEDA: "",
                });
            ClearInvoiceReferenceValues(row);
            requestRow.BLDM_INVOICEEDA = "";
            RefreshDetailRow(params);
            CalculateDetailTotal();
            if (!suppressDirty) {
                fnc.current.modify();
            }
            setEntryVersion(version => version + 1);
            return;
        }

        if (changedColumn === "BLDM_KEIHISIIRESAKICD") {
            Object.assign(
                row,
                {
                    TOR_NAME: "",
                    BLDM_INVOICENO: "",
                    BLDM_INVOICEEDA: "",
                });
            ClearInvoiceReferenceValues(row);
            requestRow.BLDM_INVOICENO = "";
            requestRow.BLDM_INVOICEEDA = "";
        }

        if (changedColumn === "BLDM_SYOYUBUMON") {
            Object.assign(
                row,
                {
                    ISSO_SYOYUSOSIKINM: "",
                    BLDM_INVOICENO: "",
                    BLDM_INVOICEEDA: "",
                });
            ClearInvoiceReferenceValues(row);
            requestRow.BLDM_INVOICENO = "";
            requestRow.BLDM_INVOICEEDA = "";
        }

        if ((changedColumn === "BLDM_INVOICENO"
            || changedColumn === "BLDM_INVOICEEDA")
            && (isEmpty(row.BLDM_INVOICENO)
                || (changedColumn === "BLDM_INVOICEEDA"
                    && isEmpty(row.BLDM_INVOICEEDA)))) {
            ClearInvoiceReferenceValues(row);
            RefreshDetailRow(params);
            CalculateDetailTotal();
            setEntryVersion(version => version + 1);
            return;
        }

        if (changedColumn === "BLDM_INVOICEEDA"
            && isEmpty(row.BLDM_INVOICENO)) {
            Object.assign(
                row,
                {
                    BLDM_INVOICEEDA: "",
                });
            ClearInvoiceReferenceValues(row);
            RefreshDetailRow(params);
            CalculateDetailTotal();
            setEntryVersion(version => version + 1);
            fnc.current.warnmsg("先にInvoiceNo.を選択または入力してください。");
            return;
        }

        if (changedColumn === "BLDM_INVOICEEDA"
            && HandleDuplicateDetailRow(
                row,
                params,
                requestRow.BLD_YUSHUTUNYUKBN)) {
            return;
        }

        fnc.current.postaxios(
            "BLInfoEntry/GetDetailReferenceInfo",
            {
                data: requestRow,
            },
            {
                onSuccess: function (data) {
                    const returnData = NormalizeRowKeys(
                        data.returnData || {});
                    if (changedColumn === "BLDM_INVOICENO") {
                        returnData.BLDM_INVOICEEDA = "";
                        returnData.IVD_MOTOINVOICEENTOTAL = 0;
                        returnData.IVD_TSUKATANI = "";
                        returnData.IVDM_KINGAKUF = 0;
                    }
                    if (!isEmpty(returnData.IVD_MOTOINVOICEENTOTAL)) {
                        returnData.IVD_MOTOINVOICEENTOTAL =
                            ToNumber(returnData.IVD_MOTOINVOICEENTOTAL);
                    }
                    if (!isEmpty(returnData.IVDM_KINGAKUF)) {
                        returnData.IVDM_KINGAKUF =
                            ToNumber(returnData.IVDM_KINGAKUF);
                    }
                    if (entryType === "1") {
                        returnData.M_CODE_NAME = "仕入先";
                    }

                    Object.assign(row, returnData);
                    RefreshDetailRow(params);
                    CalculateDetailTotal();
                    if (!suppressDirty) {
                        fnc.current.modify();
                    }
                    setEntryVersion(version => version + 1);
                },
                onError: function (data) {
                    if (changedColumn === "BLDM_INVOICENO") {
                        Object.assign(
                            row,
                            {
                                BLDM_INVOICENO: "",
                                BLDM_INVOICEEDA: "",
                            });
                        ClearInvoiceReferenceValues(row);
                    }

                    if (changedColumn === "BLDM_INVOICEEDA") {
                        Object.assign(
                            row,
                            {
                                BLDM_INVOICEEDA: "",
                            });
                        ClearInvoiceReferenceValues(row);
                    }

                    RefreshDetailRow(params);
                    CalculateDetailTotal();
                    setEntryVersion(version => version + 1);
                    if (!suppressWarning) {
                        fnc.current.warnmsg(
                            !isEmpty(data?.errDescription)
                                ? data.errDescription
                                : "明細の関連情報取得に失敗しました");
                    }
                },
                errmsg: "明細の関連情報取得に失敗しました",
            },
            true);
    }

    function DetailValueChanged(params) {
        if (isEmpty(params) || isEmpty(params.data)) {
            return;
        }

        const changedColumn = !isEmpty(params.colDef?.field)
            ? params.colDef.field
            : params.colDef?.colId;
        const referenceColumns = [
            "BLDM_KEIHISIIRESAKICD",
            "BLDM_SYOYUBUMON",
            "BLDM_INVOICENO",
            "BLDM_INVOICEEDA",
        ];

        if (!referenceColumns.includes(changedColumn)) {
            CalculateDetailTotal();
            return;
        }

        LoadDetailReferenceInfo(
            params.data,
            changedColumn,
            params);
    }

    // 取引先・所有部門・Invoice選択結果を同一Grid行へ反映し、再描画による金額消失を防止する。
    function ApplyDetailSearchResult(payload) {
        if (isEmpty(payload)
            || !Array.isArray(payload.selectedRows)
            || payload.selectedRows.length === 0) {
            return;
        }

        const selected = NormalizeRowKeys(payload.selectedRows[0]);
        const rowId = Array.isArray(payload.sourceRowIds)
            && payload.sourceRowIds.length > 0
            ? payload.sourceRowIds[0]
            : payload.currentRowId;
        const api = detailApiRef.current;
        const rowNode = isEmpty(api) || isEmpty(rowId)
            ? null
            : api.getRowNode(rowId);

        if (isEmpty(rowNode)) {
            return;
        }

        if (payload.columnInfo?.columnid
            === "BLDM_KEIHISIIRESAKICD") {
            Object.assign(
                rowNode.data,
                {
                    BLDM_KEIHISIIRESAKIKBN: "1",
                    M_CODE_NAME: "仕入先",
                    BLDM_KEIHISIIRESAKICD:
                        selected.TOR_CODE || selected.CODE || "",
                    BLDM_KEIHISIIRESAKISUBCD: "00000",
                    TOR_NAME: selected.TOR_NAME || "",
                    BLDM_INVOICENO: "",
                    BLDM_INVOICEEDA: "",
                    IVD_MOTOINVOICEENTOTAL: 0,
                    IVD_TSUKATANI: "",
                    IVDM_KINGAKUF: 0,
                });

            api.refreshCells({
                rowNodes: [rowNode],
                force: true,
            });
            CalculateDetailTotal();
            fnc.current.modify();
            setEntryVersion(version => version + 1);
            return;
        }

        if (payload.columnInfo?.columnid === "BLDM_SYOYUBUMON") {
            Object.assign(
                rowNode.data,
                {
                    BLDM_SYOYUBUMON:
                        selected.ISSO_SYOYUSOSIKICD
                        || selected.CODE
                        || "",
                    ISSO_SYOYUSOSIKINM:
                        selected.ISSO_SYOYUSOSIKINM || "",
                    BLDM_INVOICENO: "",
                    BLDM_INVOICEEDA: "",
                    IVD_MOTOINVOICEENTOTAL: 0,
                    IVD_TSUKATANI: "",
                    IVDM_KINGAKUF: 0,
                });

            api.refreshCells({
                rowNodes: [rowNode],
                force: true,
            });
            CalculateDetailTotal();
            fnc.current.modify();
            setEntryVersion(version => version + 1);
            return;
        }

        if (payload.columnInfo?.columnid !== "BLDM_INVOICENO") {
            return;
        }

        const commonValues = {
            BLDM_INVOICENO:
                selected.IVD_INVOICENO
                || selected.CODE
                || "",
            BLDM_INVOICEEDA: "",
            IVD_MOTOINVOICEENTOTAL: 0,
            IVD_TSUKATANI: "",
            IVDM_KINGAKUF: 0,
        };

        if (String(entrydataRef.current?.BLD_YUSHUTUNYUKBN || "1")
            === "1") {
            Object.assign(
                commonValues,
                {
                    BLDM_KEIHISIIRESAKIKBN:
                        selected.IVD_SIIRESAKIKBN || "1",
                    M_CODE_NAME: "仕入先",
                    BLDM_KEIHISIIRESAKICD:
                        selected.IVD_SIIRESAKICD || "",
                    BLDM_KEIHISIIRESAKISUBCD:
                        selected.IVD_SIIRESAKISUBCD || "00000",
                    TOR_NAME: selected.TOR_NAME || "",
                });
        }
        else {
            Object.assign(
                commonValues,
                {
                    BLDM_SYOYUBUMON:
                        selected.IVD_SYOYUBUMON || "",
                    ISSO_SYOYUSOSIKINM:
                        selected.ISSO_SYOYUSOSIKINM || "",
                });
        }

        Object.assign(rowNode.data, commonValues);
        api.refreshCells({
            rowNodes: [rowNode],
            force: true,
        });

        CalculateDetailTotal();
        fnc.current.modify();
        setEntryVersion(version => version + 1);
    }

    function NormalizeRowKeys(row) {
        if (isEmpty(row)) {
            return {};
        }

        return Object.keys(row).reduce((result, key) => {
            const normalizedKey = key === "rowid"
                ? key
                : String(key).toUpperCase();
            result[normalizedKey] = row[key];
            return result;
        }, {});
    }

    function FormatDateTimeText(value) {
        if (isEmpty(value)) {
            return "";
        }

        const match = String(value).match(
            /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T ](\d{1,2}):(\d{2}):(\d{2}))?/);
        if (isEmpty(match)) {
            return String(value);
        }

        const pad = target => String(target || "0").padStart(2, "0");
        return match[1]
            + "/" + pad(match[2])
            + "/" + pad(match[3])
            + " " + pad(match[4])
            + ":" + pad(match[5])
            + ":" + pad(match[6]);
    }

    function ApplyDetailData(
        rows,
        targetType = entrydataRef.current?.BLD_YUSHUTUNYUKBN || effectiveDetailType) {
        const sourceRows = Array.isArray(rows)
            ? rows
                .map(row => NormalizeRowKeys(row))
                .filter(row => String(row.BLDM_INVALID || "0") !== "1")
                .map(row => targetType !== "1"
                    ? row
                    : {
                        BLDM_KEIHISIIRESAKIKBN: "1",
                        M_CODE_NAME: "仕入先",
                        BLDM_KEIHISIIRESAKISUBCD: "00000",
                        ...row,
                    })
            : [];
        const displayRows = sourceRows.length === 0
            ? [CreateEmptyDetailRow(targetType)]
            : sourceRows;

        detailDataRef.current = displayRows;

        const api = detailApiRef.current;
        if (isEmpty(api)
            || (typeof api.isDestroyed === "function" && api.isDestroyed())) {
            return;
        }

        if (typeof api.setGridOption === "function") {
            api.setGridOption("rowData", displayRows);
        } else if (typeof api.setRowData === "function") {
            api.setRowData(displayRows);
        }

        api.forEachNode(node => {
            if (!NeedsDetailReferenceHydration(node?.data, targetType)) {
                return;
            }

            LoadDetailReferenceInfo(
                node.data,
                "__INITIAL_LOAD__",
                {
                    api: api,
                    node: node,
                },
                {
                    suppressDirty: true,
                    suppressWarning: true,
                });
        });
    }

    function LoadData(code, selectedType) {
        const requestId = detailRequestIdRef.current + 1;
        detailRequestIdRef.current = requestId;
        ClearImportPlaceOptions();
        setEntryLoading(true);
        fnc.current.wait(true);

        fnc.current.postaxios(
            "BLInfoEntry/GetData",
            {
                code: code,
                controller: entryController,
                colinfo: backendColumnInfo,
            },
            {
                onSuccess: function (data) {
                    if (requestId !== detailRequestIdRef.current) {
                        return;
                    }

                    fnc.current.margeMaster(data.master);
                    entrydataRef.current = NormalizeRowKeys(data.data);
                    entrydataRef.current.BLD_CREATEDATE =
                        FormatDateTimeText(
                            entrydataRef.current.BLD_CREATEDATE);
                    entrydataRef.current.BLD_UPDATE =
                        FormatDateTimeText(
                            entrydataRef.current.BLD_UPDATE);

                    const loadedType = entrydataRef.current.BLD_YUSHUTUNYUKBN;
                    // 既存データは登録済みのExp/Impを表示する。選択区分は新規時のみ使用する。
                    const displayType = !isEmpty(loadedType)
                        ? String(loadedType)
                        : !isEmpty(selectedType)
                            ? String(selectedType)
                            : "1";
                    entrydataRef.current.BLD_YUSHUTUNYUKBN = displayType;
                    UpdateEntryTypes(displayType);

                    const detail = isEmpty(data.detail)
                        ? []
                        : data.detail["102"];
                    ApplyDetailData(detail, displayType);
                    fnc.current.modify(false);
                    fnc.current.entryrerender();
                    setEntryVersion(version => version + 1);
                    setEntryLoading(false);
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    if (requestId !== detailRequestIdRef.current) {
                        return;
                    }

                    const message = !isEmpty(data?.errDescription)
                        ? data.errDescription
                        : "BL情報の取得に失敗しました";
                    setEntryLoading(false);
                    fnc.current.wait(false);
                    fnc.current.warnmsg(message);
                },
                errmsg: "BL情報の取得に失敗しました",
            },
            false
        );
    }

    // NEW FORMで使用する画面初期値を設定する。
    function InitializeNewForm(selectedType, callback = null) {
        detailRequestIdRef.current += 1;
        ClearImportPlaceOptions();
        ResetDetailColumnRefs();
        detailApiRef.current = null;
        listRowRef.current = null;
        setEntryLoading(false);
        const staffCode = isEmpty(staff?.staff)
            ? ""
            : String(staff.staff);

        entrydataRef.current = {
            BLD_YUSHUTUNYUKBN: selectedType,
            BLD_INPUTTANTOCD: staffCode,
            BLD_SOZAIFLG: "0",
            BLD_ZANPACHIFLG: "0",
        };
        detailDataRef.current = [CreateEmptyDetailRow(selectedType)];

        fnc.current.modify(false);
        fnc.current.entryrerender();
        setEntryVersion(version => version + 1);

        fnc.current.postaxios(
            "BLInfoEntry/GetNewEntryInitialValues",
            {},
            {
                onSuccess: function (data) {
                    const initialValues = isEmpty(data?.returnData)
                        ? {}
                        : NormalizeRowKeys(data.returnData);
                    entrydataRef.current = {
                        ...entrydataRef.current,
                        ...initialValues,
                        BLD_YUSHUTUNYUKBN: selectedType,
                    };
                    fnc.current.modify(false);
                    fnc.current.entryrerender();
                    setEntryVersion(version => version + 1);
                    fnc.current.wait(false);
                    if (typeof callback === "function") {
                        callback();
                    }
                },
                onError: function (data) {
                    const message = !isEmpty(data?.errDescription)
                        ? data.errDescription
                        : "新規画面の初期値取得に失敗しました。";
                    fnc.current.wait(false);
                    fnc.current.warnmsg(message);
                },
                errmsg: "新規画面の初期値取得に失敗しました。",
            },
            false
        );
    }

    function HasDetailInput() {
        if (!Array.isArray(detailDataRef.current)) {
            return false;
        }

        // 取引先区分などの初期値だけが設定された空行は、
        // Exp/Imp変更を妨げる明細入力とは扱わない。
        return detailDataRef.current.some(row =>
            IsDetailSaveRow(row));
    }

    function IsDetailSaveRow(row) {
        if (isEmpty(row)) {
            return false;
        }

        return !isEmpty(row.BLDM_INVOICENO)
            || !isEmpty(row.BLDM_INVOICEEDA)
            || !isEmpty(row.BLDM_KEIHISIIRESAKICD)
            || !isEmpty(row.BLDM_SYOYUBUMON);
    }

    function BuildSaveParam(noconfirm) {
        const headerBlNo = String(entrydataRef.current?.BLD_BLNO || "").trim();
        const blNo = formstatus === "ENTRY FORM" && !isEmpty(editingCode)
            ? editingCode
            : headerBlNo;
        const rows = GetCurrentDetailRows()
            .filter(row => IsDetailSaveRow(row))
            .map((row, index) => ({
                ...row,
                BLDM_BLNO: blNo,
                BLDM_GYONO: index + 1,
                BLDM_KEIHISIIRESAKIKBN:
                    entryType === "1" ? "1" : "",
                BLDM_KEIHISIIRESAKISUBCD:
                    entryType === "1" ? "00000" : "",
            }));

        CalculateDetailTotal();

        return {
            controller: entryController,
            data: {
                ...entrydataRef.current,
                BLD_BLNO: blNo,
                BLD_YUSHUTUNYUKBN: entryType,
                BLD_ENTOTAL: ToNumber(
                    entrydataRef.current?.BLD_ENTOTAL),
            },
            detail: {
                "102": rows,
            },
            colinfo: backendColumnInfo,
            code: blNo,
            noconfirm: noconfirm,
        };
    }

    function CreateInputWarning(
        rowid,
        table,
        type,
        columnid,
        columnnm,
        message) {
        return {
            rowid: rowid,
            table: table,
            type: type,
            col: columnid,
            columnnm: columnnm,
            message: message,
        };
    }

    function IsValidDateText(value) {
        const text = String(value || "").trim();
        const match = text.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
        if (isEmpty(match)) {
            return false;
        }

        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const date = new Date(year, month - 1, day);

        return date.getFullYear() === year
            && date.getMonth() === month - 1
            && date.getDate() === day;
    }

    function IsHalfWidthText(value) {
        return /^[\x20-\x7e]*$/.test(String(value || ""));
    }

    function ValidateBeforeSave(param) {
        const header = param.data || {};
        const blNo = String(header.BLD_BLNO || "").trim();
        const inputDate = String(header.BLD_INPUTDATE || "").trim();

        if (isEmpty(blNo)) {
            fnc.current.warnmsg("B/L No.を入力してください。");
            return false;
        }

        if (blNo.length > 24) {
            fnc.current.warnmsg("B/L No.は24桁以内で入力してください。");
            return false;
        }

        if (!IsHalfWidthText(blNo) || !/^[0-9A-Za-z]+$/.test(blNo)) {
            fnc.current.warnmsg("B/L No.は半角英数字で入力してください。");
            return false;
        }

        if (isEmpty(inputDate)) {
            fnc.current.warnmsg("入力日を入力してください。");
            return false;
        }

        return true;
    }

    function Save(finallycallback, noconfirm, listcallback) {
        const isUpdate = formstatus === "ENTRY FORM"
            && !isEmpty(editingCode);
        const param = BuildSaveParam(noconfirm);

        if (param.detail["102"].length === 0) {
            fnc.current.warnmsg("登録対象の明細を入力してください。");
            return;
        }

        if (!ValidateBeforeSave(param)) {
            return;
        }

        fnc.current.wait(true);
        fnc.current.postaxios(
            isUpdate
                ? "BLInfoEntry/UpdateEntry"
                : "BLInfoEntry/InsertEntry",
            param,
            {
                onSuccess: function (data) {
                    const warnings = Array.isArray(data.warning)
                        ? data.warning
                        : [];

                    if (warnings.length !== 0) {
                        if (isUpdate
                            && isEnabled(data.confirm)) {
                            fnc.current.confmsg(
                                warnings.map(warning => warning.message),
                                () => Save(
                                    finallycallback,
                                    true,
                                    listcallback));
                            fnc.current.wait(false);
                            return;
                        }

                        fnc.current.showwarndescription(
                            "登録内容を確認してください。",
                            warnings);
                        fnc.current.wait(false);
                        return;
                    }

                    const code = !isEmpty(data.request)
                        ? String(data.request)
                        : String(param.data?.BLD_BLNO || editingCode || "").trim();
                    entrydataRef.current = {
                        ...entrydataRef.current,
                        BLD_BLNO: code,
                    };
                    setEditingCode(code);
                    fnc.current.modify(false);
                    fnc.current.success();
                    if (typeof listcallback === "function") {
                        listReloadRef.current = listcallback;
                        listReloadRequiredRef.current = true;
                    }

                    if (!isUpdate) {
                        dispatch(changestatus("ENTRY FORM"));
                    }

                    if (isUpdate
                        && typeof finallycallback === "function") {
                        finallycallback({
                            ...(listRowRef.current || {}),
                            ...entrydataRef.current,
                            rowid: listRowRef.current?.rowid,
                        });
                    }

                    LoadData(code, entryType);
                },
                onError: function (data) {
                    const message = !isEmpty(data?.errDescription)
                        ? data.errDescription
                        : "登録に失敗しました。";
                    fnc.current.wait(false);
                    fnc.current.warnmsg(message);
                },
                errmsg: "登録に失敗しました。",
            },
            false);
    }

    function IsValidImportFile(file) {
        if (isEmpty(file)) {
            return false;
        }

        switch (file.type) {
            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                return true;
            default:
                break;
        }

        const extension = String(GetExtension(file.name) || "")
            .toLowerCase();
        return extension === "xls" || extension === "xlsx";
    }

    function OpenImportFileDialog() {
        if (isEmpty(importFileRef.current)) {
            fnc.current.warnmsg("取込用のファイル選択を開始できませんでした。");
            return;
        }

        importFileRef.current.value = "";
        importFileRef.current.click();
    }

    function HandleImportFileChange(event) {
        const file = event?.target?.files?.[0];
        event.target.value = "";

        if (isEmpty(file)) {
            return;
        }

        if (!IsValidImportFile(file)) {
            fnc.current.warnmsg("Excelファイル（.xls / .xlsx）を指定してください。");
            return;
        }

        if (file.size > 10000000) {
            fnc.current.warnmsg("選択ファイルはアップロード可能なファイルサイズを超えています。");
            return;
        }

        fnc.current.formdialogopen({
            title: "Excelデータ取込",
            dialogtype: 9,
            customcontents: 2,
            checkboxlabel: "先頭行を取り込む（ヘッダ行がないExcelシートの取り込みの場合チェック）",
            contents: "Invoiceデータ検索のExcel形式を読み込み、現在DBで有効な"
                + GetPlaceCodeLabel(entryType)
                + "候補を抽出します。よろしいですか？",
            onApply: (param) => ImportDetailExcel(file, isEnabled(param?.check)),
        });
    }

    function FinalizeImportedDetailRows(candidateRows, targetType, serverMessage, duplicateWarnings = []) {
        const candidateCount = Array.isArray(candidateRows)
            ? candidateRows.length
            : 0;
        const importedCount = AppendImportedDetailRows(
            candidateRows,
            targetType,
            true);
        fnc.current.wait(false);

        if (duplicateWarnings.length > 0) {
            const summary = !isEmpty(serverMessage)
                ? serverMessage
                : candidateCount.toString()
                    + "件の場所コード候補を抽出しました。";
            fnc.current.successmsg(
                importedCount.toString()
                + "件の場所コード候補を抽出しました。");
            fnc.current.showwarndescription(
                summary,
                duplicateWarnings);
            return;
        }

        fnc.current.successmsg(
            !isEmpty(serverMessage)
                ? serverMessage
                : importedCount.toString()
                    + "件の場所コード候補を抽出しました。");
    }

    function ImportDetailExcel(file, includeHeader) {
        if (!isEmpty(entryTransitionTimerRef.current)) {
            clearTimeout(entryTransitionTimerRef.current);
            entryTransitionTimerRef.current = null;
        }

        fnc.current.formdialogclose();
        fnc.current.wait(true);

        fnc.current.fileupload(
            "excel/GetExcelFileData",
            {
                file: file,
                importmode: true,
                colcount: 3,
            },
            {
                onSuccess: function (data) {
                    const currentImportType = String(
                        entrydataRef.current?.BLD_YUSHUTUNYUKBN
                        || entryType
                        || "1").trim() === "2"
                        ? "2"
                        : "1";
                    const rawRowsAll = Array.isArray(data?.data)
                        ? data.data
                        : [];
                    const headerRow = rawRowsAll.length > 0
                        ? rawRowsAll[0]
                        : [];
                    const headerTitle = String(headerRow?.[0] || "").trim();

                    if (!includeHeader) {
                        const importedType = DetectImportEntryTypeFromHeader(headerTitle)
                            || (headerTitle === "場所コード"
                                ? DetectImportEntryTypeFromFileName(file?.name)
                                : "");
                        if (isEmpty(importedType)) {
                            fnc.current.wait(false);
                            fnc.current.showwarndescription(
                                "取込を中止しました。",
                                BuildImportHeaderWarnings(
                                    file?.name,
                                    headerTitle,
                                    "1行目タイトルから輸入/輸出を判定できません。"));
                            return;
                        }

                        if (importedType !== currentImportType) {
                            const currentStatus = String(formstatusRef.current || "").trim();
                            const currentTypeLabel = GetEntryTypeLabel(currentImportType);
                            const importedTypeLabel = GetEntryTypeLabel(importedType);
                            const mismatchWarnings = BuildImportHeaderWarnings(
                                file?.name,
                                headerTitle,
                                "現在の画面は「"
                                + currentTypeLabel
                                + "」ですが、取込ファイルは「"
                                + importedTypeLabel
                                + "」です。");

                            if (currentStatus === "NEW FORM") {
                                fnc.current.wait(false);
                                fnc.current.confmsg(
                                    [
                                        "取込ファイルの1行目タイトルは「" + headerTitle + "」です。",
                                        "現在の画面は「" + currentTypeLabel + "」です。",
                                        "「" + importedTypeLabel + "」の新規画面へ切り替えて取込を続けますか。",
                                    ],
                                    () => {
                                        fnc.current.wait(true);
                                        BaseValueChanging(
                                            "BLD_YUSHUTUNYUKBN",
                                            importedType);
                                        fnc.current.entryrerender();
                                        setEntryVersion(version => version + 1);
                                        InitializeNewForm(importedType, () => {
                                            ImportDetailExcel(file, includeHeader);
                                        });
                                    },
                                    () => {
                                        fnc.current.showwarndescription(
                                            "取込を中止しました。",
                                            mismatchWarnings);
                                    });
                                return;
                            }

                            fnc.current.wait(false);
                            fnc.current.showwarndescription(
                                "取込を中止しました。",
                                mismatchWarnings);
                            return;
                        }
                    }

                    const rawRows = includeHeader
                        ? rawRowsAll
                        : rawRowsAll.slice(1);
                    const importRows = rawRows.map((row, index) => ({
                        PLACECODE: String(row?.[0] || "").trim(),
                        INVOICENO: String(row?.[1] || "").trim(),
                        INVOICEEDA: String(row?.[2] || "").trim(),
                        IMPORT_ROWNO: includeHeader ? index + 1 : index + 2,
                    }));
                    const formatWarning = FindImportFormatWarning(
                        importRows,
                        file?.name);
                    if (!isEmpty(formatWarning)) {
                        fnc.current.wait(false);
                        fnc.current.showwarndescription(
                            "取込を中止しました。",
                            [formatWarning]);
                        return;
                    }
                    const duplicateInfo = SplitImportedRowsByDuplicate(
                        importRows,
                        currentImportType);
                    const duplicateWarnings = BuildImportDuplicateWarnings(
                        file?.name,
                        duplicateInfo.duplicateRows);

                    const executeImport = (targetRows, warnings = []) => {
                        if (!Array.isArray(targetRows) || targetRows.length === 0) {
                            fnc.current.wait(false);
                            if (warnings.length > 0) {
                                fnc.current.showwarndescription(
                                    "以下のデータは取り込みませんでした。",
                                    warnings);
                                return;
                            }
                            fnc.current.warnmsg("有効な取込データがありませんでした。");
                            return;
                        }

                        fnc.current.postaxios(
                            "BLInfoEntry/GetImportDetailRows",
                            {
                                code: editingCode,
                                data: {
                                    BLD_BLNO: editingCode,
                                    BLD_YUSHUTUNYUKBN: currentImportType,
                                },
                                rowdata: targetRows,
                            },
                            {
                                onSuccess: function (result) {
                                    const candidateRows = Array.isArray(result?.rowdata)
                                        ? result.rowdata
                                        : [];
                                    const excludedRows = Array.isArray(result?.master)
                                        ? result.master
                                        : [];
                                    const excludedWarnings = BuildImportExcludedWarnings(
                                        file?.name,
                                        excludedRows);
                                    const options = BuildImportPlaceOptions(
                                        candidateRows,
                                        currentImportType);

                                    SetImportPlaceOptions(currentImportType, options);

                                    if (excludedWarnings.length > 0 && options.length === 0) {
                                        fnc.current.wait(false);
                                        fnc.current.showwarndescription(
                                            "以下のデータは取り込みませんでした。",
                                            excludedWarnings);
                                        return;
                                    }

                                    if (excludedWarnings.length > 0) {
                                        fnc.current.wait(false);
                                        fnc.current.confmsg(
                                            "現在のInvoiceマスタに一致しないデータがあります。"
                                            + "\n該当データを除外して取込を続行しますか。",
                                            () => {
                                                fnc.current.wait(true);
                                                FinalizeImportedDetailRows(
                                                    candidateRows,
                                                    currentImportType,
                                                    result?.errDescription,
                                                    duplicateWarnings);
                                                fnc.current.showwarndescription(
                                                    "以下のデータは取り込みませんでした。",
                                                    excludedWarnings);
                                            },
                                            () => {
                                                fnc.current.showwarndescription(
                                                    "以下のデータは取り込みませんでした。",
                                                    excludedWarnings);
                                            });
                                        return;
                                    }

                                    if (options.length === 0) {
                                        fnc.current.wait(false);
                                        fnc.current.warnmsg(
                                            "有効な" + GetPlaceCodeLabel(currentImportType) + "候補がありませんでした。");
                                        return;
                                    }

                                    FinalizeImportedDetailRows(
                                        candidateRows,
                                        currentImportType,
                                        result?.errDescription,
                                        duplicateWarnings);
                                },
                                onError: function (result) {
                                    fnc.current.wait(false);
                                    fnc.current.warnmsg(
                                        !isEmpty(result?.errDescription)
                                            ? result.errDescription
                                            : "データ取込に失敗しました。");
                                },
                                errmsg: "データ取込に失敗しました。",
                            },
                        );
                    };

                    if (duplicateWarnings.length > 0) {
                        fnc.current.wait(false);
                        fnc.current.confmsg(
                            "取込データ内、または画面上の明細データと重複するインボイスがあります。"
                            + "\n重複データを除外して取込を続行しますか。",
                            () => {
                                fnc.current.wait(true);
                                executeImport(duplicateInfo.rows, duplicateWarnings);
                            },
                            () => {
                                fnc.current.showwarndescription(
                                    "取込を中止しました。",
                                    duplicateWarnings);
                            });
                        return;
                    }

                    executeImport(duplicateInfo.rows, []);
                },
                onError: function () {
                    fnc.current.wait(false);
                    fnc.current.warnmsg("Excelファイルの読込に失敗しました。");
                },
                errmsg: "Excelファイルの読込に失敗しました。",
            }
        );
    }

    // NEW FORMのExp/Imp変更時に明細構成を切り替える。
    function BaseValueChanging(columnid, value) {
        if (columnid !== "BLD_YUSHUTUNYUKBN"
            || (value !== "1" && value !== "2")
            || value === entryType) {
            return;
        }

        if (HasDetailInput()) {
            entrydataRef.current = {
                ...entrydataRef.current,
                BLD_YUSHUTUNYUKBN: entryType,
            };
            fnc.current.entryrerender();
            fnc.current.warnmsg(
                "明細が入力されているため、Exp/Impを変更できません。");
            return;
        }

        entrydataRef.current = {
            ...entrydataRef.current,
            BLD_YUSHUTUNYUKBN: value,
        };
        detailDataRef.current = [CreateEmptyDetailRow(value)];
        ResetDetailColumnRefs();
        detailApiRef.current = null;
        UpdateEntryTypes(value);
    }

    // 一覧から詳細画面へ遷移する際、輸出入区分と選択行を保持する。
    function Show(data, pushcode, option) {
        const currentEntryData = isEmpty(entrydataRef.current)
            ? {}
            : DeepCopy(entrydataRef.current);
        const optionType = isEmpty(option)
            ? ""
            : String(option).trim();
        const currentType = isEmpty(currentEntryData.BLD_YUSHUTUNYUKBN)
            ? ""
            : String(currentEntryData.BLD_YUSHUTUNYUKBN).trim();

        if (formstatus === "ENTRY FORM"
            && isEmpty(data)
            && isEmpty(pushcode)) {
            const resolvedType = optionType === "1" || optionType === "2"
                ? optionType
                : currentType === "1" || currentType === "2"
                    ? currentType
                    : "1";

            if (!isEmpty(entryTransitionTimerRef.current)) {
                clearTimeout(entryTransitionTimerRef.current);
                entryTransitionTimerRef.current = null;
            }

            entryTransitionTimerRef.current = window.setTimeout(() => {
                entryTransitionTimerRef.current = null;

                if (formstatusRef.current === "NEW FORM") {
                    listRowRef.current = null;
                    setEditingCode("");
                    InitializeNewForm(resolvedType);
                    return;
                }

                if (formstatusRef.current === "ENTRY FORM"
                    && !isEmpty(editingCode)) {
                    LoadData(editingCode, GetEffectiveDetailType());
                }
            }, 0);

            return true;
        }

        const fallbackSource = !isEmpty(listRowRef.current)
            ? DeepCopy(listRowRef.current)
            : currentEntryData;
        const source = isEmpty(data)
            ? fallbackSource
            : DeepCopy(data);
        listRowRef.current = source;
        const sourceType = isEmpty(source.BLD_YUSHUTUNYUKBN)
            ? ""
            : String(source.BLD_YUSHUTUNYUKBN).trim();
        const selectedType = optionType === "1" || optionType === "2"
            ? optionType
            : sourceType === "1" || sourceType === "2"
                ? sourceType
                : currentType === "1" || currentType === "2"
                    ? currentType
                    : "";
        const yushutunyuKbn = !isEmpty(selectedType)
            ? selectedType
            : "1";

        entrydataRef.current = {
            BLD_YUSHUTUNYUKBN: yushutunyuKbn,
        };
        detailDataRef.current = [CreateEmptyDetailRow(yushutunyuKbn)];
        ClearImportPlaceOptions();
        ResetDetailColumnRefs();
        detailApiRef.current = null;
        UpdateEntryTypes(yushutunyuKbn);

        const code = !isEmpty(pushcode)
            ? pushcode
            : !isEmpty(source.BLD_BLNO)
                ? source.BLD_BLNO
                : "";
        if (!isEmpty(code)) {
            setEditingCode(String(code));
            LoadData(code, selectedType);
        } else {
            setEditingCode("");
            InitializeNewForm(yushutunyuKbn);
        }

        return true;
    }

    function EntryAction(menu, finallycallback, listcallback, gridApi) {
        if (menu === "close") {
            const reloadList = listReloadRef.current;
            const reloadRequired = listReloadRequiredRef.current;
            detailRequestIdRef.current += 1;
            entrydataRef.current = null;
            detailDataRef.current = [];
            ResetDetailColumnRefs();
            detailApiRef.current = null;
            listRowRef.current = null;
            listReloadRef.current = null;
            listReloadRequiredRef.current = false;
            ClearImportPlaceOptions();
            setEntryLoading(false);
            setEditingCode("");
            if (reloadRequired
                && typeof reloadList === "function") {
                reloadList(false, true);
            }
            return;
        }

        if (menu === "new") {
            const currentType = GetEffectiveDetailType();
            ClearImportPlaceOptions();
            ResetDetailColumnRefs();
            detailApiRef.current = null;
            listRowRef.current = null;
            setEntryLoading(false);
            setEditingCode("");
            UpdateEntryTypes(currentType);
            InitializeNewForm(currentType);
            return;
        }

        if (menu === "save") {
            Save(finallycallback, false, listcallback);
            return;
        }

        if (menu === "delete") {
            const entryData = isEmpty(entrydataRef.current)
                ? {}
                : entrydataRef.current;
            const blNo = !isEmpty(editingCode)
                ? editingCode
                : entryData.BLD_BLNO;

            if (isEmpty(blNo)) {
                fnc.current.warnmsg("削除対象のB/L No.を取得できませんでした");
                return;
            }

            fnc.current.confmsg(
                "B/L No.「"
                    + blNo
                    + "」を削除します。"
                    + "このデータは使用できなくなります。"
                    + "よろしいですか？",
                () => Delete(finallycallback));
            return;
        }

        if (menu === "blexcel") {
            if (isEmpty(gridApi)) {
                fnc.current.warnmsg("Excel出力対象の一覧を取得できませんでした");
                return;
            }

            gridApi.exportDataAsExcel({
                fileName: GetExcelFileName(),
            });
            return;
        }

        if (menu === "blimport") {
            OpenImportFileDialog();
            return;
        }

        if (menu === "clear") {
            if (formstatus === "ENTRY FORM"
                && !isEmpty(editingCode)) {
                LoadData(editingCode, GetEffectiveDetailType());
            } else {
                const currentType = GetEffectiveDetailType();
                ClearImportPlaceOptions();
                ResetDetailColumnRefs();
                detailApiRef.current = null;
                UpdateEntryTypes(currentType);
                InitializeNewForm(currentType);
            }
        }
    }

    function Delete(finallycallback, noconfirm = false) {
        const entryData = isEmpty(entrydataRef.current)
            ? {}
            : entrydataRef.current;
        const blNo = !isEmpty(editingCode)
            ? editingCode
            : entryData.BLD_BLNO;
        const param = {
            code: blNo,
            data: entryData,
            rowdata: [
                {
                    BLD_BLNO: blNo,
                    rowid: blNo,
                },
            ],
            controller: controller,
            noconfirm: noconfirm,
        };

        fnc.current.wait(true);
        fnc.current.postaxios(
            "BLInfoEntry/Delete",
            param,
            {
                onSuccess: function (data) {
                    const warnings = Array.isArray(data.warning)
                        ? data.warning
                        : [];

                    if (warnings.length === 0) {
                        fnc.current.modify(false);
                        fnc.current.success();
                        listReloadRequiredRef.current = true;

                        if (typeof finallycallback === "function") {
                            finallycallback(blNo, ["BLD_BLNO"]);
                        }
                    } else if (isEnabled(data.confirm)) {
                        fnc.current.confmsg(
                            warnings.map(warning => warning.message),
                            () => Delete(finallycallback, true));
                    } else {
                        fnc.current.showwarndescription(
                            "このデータは削除できません。",
                            warnings);
                    }

                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "BL情報の削除に失敗しました。");
                    fnc.current.wait(false);
                },
                errmsg: "BL情報の削除に失敗しました。",
            });
    }

    function HandleListCellDoubleClick(params) {
        const row = isEmpty(params?.data)
            ? {}
            : params.data;
        const blNo = isEmpty(row.BLD_BLNO)
            ? ""
            : String(row.BLD_BLNO).trim();

        if (isEmpty(blNo)) {
            fnc.current.warnmsg("関連するBL情報がないため、詳細画面へ遷移できません。");
            return true;
        }
        // 共通側で現在選択中のExp/Impを option として Show に渡させる。
        // ここで行データの区分を直接使うと、一覧側で切り替えた区分が反映されない。
        return false;
    }

    function SetDetailColumnStyle(column) {
        const width = GetDetailColumnWidth(column.colId);
        column.width = width;
        column.minWidth = Math.min(width, 100);
        column.flex = 1;

    }

    function Panel(targetPanel, contents) {
        return (
            <Box
                key={targetPanel.id + "_" + targetPanel.type}
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                padding="5px"
            >
                <Paper
                    style={{
                        width: "100%",
                        height: "auto",
                        padding: 10,
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            marginBottom: 5,
                        }}
                    >
                        {targetPanel.name}
                    </div>
                    {contents}
                </Paper>
            </Box>
        );
    }

    function RenderDetailGrid(forceType) {
        const columninfo = forceType === "2"
            ? outputDetailFields
            : inputDetailFields;
        const columns = forceType === "2"
            ? outputDetailColumns
            : inputDetailColumns;
        const gridKey = "BLInfoEntryDetail_"
            + forceType
            + "_"
            + editingCode
            + "_"
            + (entrydataRef.current?.BLD_BLNO || "");
        const columnRef = GetDetailColumnRef(forceType);

        return (
            <EntryGridAr
                key={gridKey}
                id={gridKey}
                entrydataRef={entrydataRef}
                dataRef={detailDataRef}
                columnRef={columnRef}
                columninfo={columninfo}
                columns={columns}
                fnc={fnc}
                formid={formid}
                panel={detailPanel}
                ColdefSpecial={SetDetailColumnStyle}
                ValueChanged={DetailValueChanged}
                SearchResultApplied={ApplyDetailSearchResult}
                QueryAddRow={InitializeAddedDetailRows}
                onGridReady={params => {
                    detailApiRef.current = params.api;
                    ApplyDetailData(
                        detailDataRef.current,
                        forceType);
                }}
            />
        );
    }

    function EntryForm() {
        return (
            <div
                data-entry-type={effectiveDetailType}
                aria-label={effectiveDetailType === "2" ? "輸出用" : "輸入用"}
                style={{
                    padding: "5px 15px",
                    paddingBottom: 100,
                    height: "100%",
                    overflow: "auto",
                    backgroundColor: "#D8D8D8",
                }}
            >
                {Panel(
                    statusPanel,
                    <EntryBase
                        fnc={fnc}
                        textfields={statusFields}
                        panel={statusPanel}
                        entrydataRef={entrydataRef}
                        layoutlock={true}
                        settextfields={() => { }}
                    />
                )}

                {Panel(
                    basePanel,
                    <EntryBase
                        fnc={fnc}
                        textfields={baseFields}
                        panel={basePanel}
                        entrydataRef={entrydataRef}
                        layoutlock={true}
                        settextfields={() => { }}
                        ValueChangeing={BaseValueChanging}
                    />
                )}

                {Panel(
                    detailPanel,
                    <React.Fragment>
                        {!entryLoading && (
                            effectiveDetailType === "2"
                                ? RenderDetailGrid("2")
                                : RenderDetailGrid("1")
                        )}
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            paddingTop="5px"
                        >
                            <Paper
                                style={{
                                    width: 320,
                                    padding: 10,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <span>金額計</span>
                                    <span
                                        style={{
                                            fontSize: 18,
                                            fontWeight: "bold",
                                            textAlign: "right",
                                        }}
                                    >
                                        {FormatTotalAmount(
                                            entrydataRef.current?.BLD_ENTOTAL)}
                                    </span>
                                </div>
                            </Paper>
                        </Box>
                    </React.Fragment>
                )}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={SetComFunctionRef} />
            <input
                ref={importFileRef}
                type="file"
                accept=".xls,.xlsx"
                style={{ display: "none" }}
                onChange={HandleImportFileChange}
            />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={EntryAction}
                entryform={true}
                tabs={true}
                show={Show}
                listcelldoubleclick={HandleListCellDoubleClick}
                navmenu={navmenu}
                suppressaction={suppressaction}
                entrydataRef={entrydataRef}
                excelfilename={GetExcelFileName}
                usecondition={true}
            >
                {EntryForm()}
            </MasterBase>
        </div>
    );
};
